var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8221_2257)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18.5,
    r: 17.5,
    fill: "currentColor",
    fillOpacity: 0.5,
    stroke: "#373737",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.35355,
    y1: 5.14645,
    x2: 31.3536,
    y2: 31.1464,
    stroke: "#545454",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.35355,
    y1: 5.14645,
    x2: 31.3536,
    y2: 31.1464,
    stroke: "#373737",
    strokeWidth: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8221_2257"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorUnavailable);
export default __webpack_public_path__ + "static/media/color-unavailable.f40ff09938de01350c022529a82e9fb3.svg";
export { ForwardRef as ReactComponent };